import React from "react";
import {
    Box,
    Button,
    Checkbox,
    Flex,
    Grid,
    Tag,
    Text,
    Tooltip,
} from "@chakra-ui/react";
import { formatDateTime } from "utils/dateUtils/dateUtils";

interface CardProps {
    data: any[];
}

export default function SdkOrderCard({
    data,
}: CardProps) {
    const getStatusColor = (status: string) => {
        switch (status) {
            case "SUCCESSFUL":
            case "REFUNDED":
                return "green";
            case "PAYMENT_FAILED":
            case "CANCELLED":
                return "red";
            case "PAYMENT_INITIATED":
            case "CANCEL_INITIATED":
                return "orange";
            default:
                return "gray";
        }
    };

    return (
        <>
            <Grid templateColumns="1fr" gap={4}>
                {data?.map((txn: any) => {
                    const providers =
                        txn?.orders?.map((o: any) => o.providerName) || [];
                    const providerLabel =
                        [...new Set(providers)].length > 1
                            ? "Multiple"
                            : providers[0] || "N/A";

                    return (
                        <Box
                            key={txn._id}
                            p={4}
                            shadow="base"
                            borderRadius="lg"
                            bg="white"
                        >
                            <Flex justify="space-between" mb={2}>
                                <Tooltip label={txn?._id}>
                                    <Text
                                        fontWeight="bold"
                                        color="teal.500"
                                        isTruncated={true}
                                        w={"10rem"}
                                        cursor="pointer"
                                    >
                                        Transaction ID: {txn?._id}
                                    </Text>
                                </Tooltip>
                            </Flex>

                            <Flex justify="space-between" mb={2}>
                                <Text>User: {txn?.user?.name || txn?.billingDetails?.name || "N/A"}</Text>
                            </Flex>
                            <Flex justify="space-between" mb={2}>
                                <Text>Phone: {txn?.user?.moNumber || txn?.billingDetails?.phone || "N/A"}</Text>
                            </Flex>

                            <Flex justify="space-between" mb={2}>
                                <Text>
                                    Stations: {txn?.startStation || "N/A"} →{" "}
                                    {txn?.destinationStation || "N/A"}
                                </Text>
                            </Flex>

                            <Flex justify="space-between" mb={2}>
                                <Text>Providers: {providerLabel}</Text>
                            </Flex>

                            <Flex justify="space-between" mb={2}>
                                <Text>Tickets: {txn?.ticketCount || 0}</Text>
                            </Flex>

                            <Flex justify="space-between" mb={2}>
                                <Text>Total Fare: ₹ {txn?.totalPrice || 0}</Text>
                            </Flex>

                            <Flex justify="space-between" mb={2}>
                                <Text>Date: {formatDateTime(txn?.createdAt, "DD-MM-YYYY")}</Text>
                            </Flex>

                            <Flex justifyContent="flex-end" alignItems="center">
                                <Tag
                                    size={"sm"}
                                    mt={2}
                                    colorScheme={getStatusColor(txn?.status)}
                                    ml={2}
                                    py={1}
                                    px={2}
                                    borderRadius="md"
                                >
                                    {txn?.status}
                                </Tag>
                            </Flex>
                        </Box>
                    );
                })}
            </Grid>
        </>
    );
}
